import React from "react";

const CategoryThree = () => {
  return (
    <>
      {/* <!-- cta area start --> */}
      <div className="tp-cta-area pt-140">
        <div className="container">
          <div className="tp-cta-wrapper">
            <div className="row">
              <div className="col-12">
                <div className="tp-section-wrapper text-center">
                  <span className="tp-section-subtitle mb-25">
                    Connect with Us
                  </span>
                  <h2 className="tp-section-title">
                    Let’s Build Something Great Together
                  </h2>
                  <h3>
                    Lets Talk, Get in touch circle let it lead to the bottom of
                    the page where they fill in contact form.
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- cta end end --> */}
    </>
  );
};

export default CategoryThree;
